"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A function that always returns the Boolean value of `false`
 */
function alwaysFalse() {
    return false;
}
exports.default = alwaysFalse;
//# sourceMappingURL=alwaysFalse.js.map